import React,{useEffect, useRef} from 'react'
import SearchIcon from '@mui/icons-material/Search';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import {useLoadScript} from '@react-google-maps/api'
import './map.css'
import geolocation from 'geolocation';
const libraries = ["places"];
const MapInput = ({setValues,values,update}) => {
    const isFetchingLocation = useRef(false);
const hasFetchedLocation = useRef(false);
    const {isLoaded}=useLoadScript({googleMapsApiKey:process.env.REACT_APP_GOOGLEAPI,libraries})
    const searchInput = useRef()


  const apiKey = process.env.REACT_APP_GOOGLEAPI;
  const geocodeJson = 'https://maps.googleapis.com/maps/api/geocode/json';



    const onChangeAddress = (autocomplete) => {
        const place = autocomplete.getPlace();
        
        if (!place.geometry) return;


        const location={
            latitude:place.geometry.location.lat(),
            longitude:place.geometry.location.lng(),
             place_name: place.name,
            formatted_address:place.formatted_address
        }
        setValues((values) => ({
            ...values,
             gLocation:location
         }));
      }

    const initAutocomplete = () => {
        if (!searchInput.current) return;
        const autocomplete = new window.google.maps.places.Autocomplete(searchInput.current,{
          types: ["establishment"],
          componentRestrictions: { country: ["IN", "GB", "PK"]  } // "IN" is the country code for India
        });
        autocomplete.setFields([ "name","address_component", "geometry","formatted_address"]);
        autocomplete.addListener("place_changed", () => onChangeAddress(autocomplete));
      }

      useEffect(()=>{
       if(isLoaded){
        initAutocomplete()
       }
      },[isLoaded])


      const reverseGeocodeFromBackend = async ({ latitude, longitude }) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BASEURL}/reverse-geocode`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ latitude, longitude }),
            credentials: 'include'
        });

        const data = await response.json();
        if (data.formatted_address) {
            searchInput.current.value = data.formatted_address;

            setValues(prev => ({
                ...prev,
                gLocation: {
                    latitude: data.latitude,
                    longitude: data.longitude,
                    formatted_address: data.formatted_address,
                    place_name:data.place_name
                }
            }));

            hasFetchedLocation.current = true;
        } else {
            searchInput.current.value = "Location fetch failed";
        }

    } catch (err) {
        searchInput.current.value = "Location error";
    } finally {
        isFetchingLocation.current = false;
    }
};

    
    const findMyLocation = () => {

    // prevent multiple clicks while loading
    if (isFetchingLocation.current) return;

    // prevent refetch if already selected
    if (hasFetchedLocation.current) return;

    isFetchingLocation.current = true;

    searchInput.current.value = "Getting your location...";

    geolocation.getCurrentPosition((err, position) => {

        if (!err) {
            const { latitude, longitude } = position.coords;
            reverseGeocodeFromBackend({ latitude, longitude });
        } else {
            isFetchingLocation.current = false;
        }

    });
};

  return (
    <div className='search'>
         <span className='map-search'><SearchIcon/></span>
        <input ref={searchInput} type="text" name="" id=""   placeholder={update?"Search for your venue":"Search for your venue"} />
         <span className='gps-search'  onClick={findMyLocation}><GpsFixedIcon/></span>
    </div>
  )
}

export default MapInput
